import * as Dialog from "@radix-ui/react-dialog";
import styled from "styled-components";

export const TransferDialogContent = styled(Dialog.Content)`
  width: min(92vw, 840px);
  max-width: 840px;
  padding: 0;
  overflow: auto;
  border-radius: 28px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.99) 0%, rgba(255, 255, 255, 0.96) 100%);
  border: 1px solid rgba(226, 232, 240, 0.9);
  box-shadow: 0 32px 90px rgba(15, 23, 42, 0.18);
  scrollbar-width: thin;
`;

export const TransferDialogBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem;

  @media (max-width: 640px) {
    padding: 1.25rem;
  }
`;

export const TransferHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
`;

export const TransferBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  border-radius: 999px;
  border: 1px solid rgba(225, 29, 72, 0.12);
  background: rgba(225, 29, 72, 0.08);
  padding: 0.4rem 0.75rem;
  color: #be123c;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
`;

export const TransferSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.1rem;
  border-radius: 24px;
  border: 1px solid rgba(226, 232, 240, 0.9);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(255, 241, 242, 0.45));
  box-shadow: 0 14px 35px rgba(15, 23, 42, 0.04);
`;

export const TransferSectionHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
`;

export const TransferSectionTitle = styled.h3`
  margin: 0;
  font-family: ${(props) => props.theme.fonts.heading};
  font-size: 0.98rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: ${(props) => props.theme.colors.text};
`;

export const TransferSectionDescription = styled.p`
  margin: 0.3rem 0 0;
  color: ${(props) => props.theme.colors.textSecondary};
  font-size: 0.86rem;
  line-height: 1.6;
`;

export const TransferFieldGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const TransferFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  margin-top: 0.25rem;
`;

export const TransferFooterNote = styled.p`
  margin: 0;
  max-width: 28rem;
  color: ${(props) => props.theme.colors.textSecondary};
  font-size: 0.84rem;
  line-height: 1.6;
`;
